import { Layers } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    try {
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const redirectUri = window.location.origin + "/auth/google";
      const res = await api.get("/auth/google/url", { params: { redirect_uri: redirectUri } });
      sessionStorage.setItem("oauth_state", res.data.state);
      window.location.href = res.data.url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not start Google sign-in.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full grid lg:grid-cols-2 bg-white">
      {/* Left: brand / hero */}
      <div className="hidden lg:flex relative flex-col justify-between p-12 overflow-hidden bg-[#003366]">
        <img
          src="https://images.unsplash.com/photo-1579548122080-c35fd6820ecb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
          alt=""
          className="absolute inset-0 h-full w-full object-cover opacity-30"
        />
        <div className="relative flex items-center gap-2 text-white">
          <Layers className="h-6 w-6" />
          <span className="font-display font-extrabold text-xl tracking-tight">Revora</span>
        </div>
        <div className="relative text-white max-w-md">
          <h1 className="font-display font-extrabold tracking-tight text-4xl lg:text-5xl leading-tight">
            Organize. Study. Remember.
          </h1>
          <p className="mt-4 text-white/70 text-base leading-relaxed">
            Folders, decks, and flip-cards — a calm, focused space to master anything.
          </p>
        </div>
        <div className="relative text-white/50 text-sm">Made for focused minds.</div>
      </div>

      {/* Right: auth */}
      <div className="flex flex-col items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2 lg:hidden mb-8">
            <Layers className="h-6 w-6 text-[#003366]" />
            <span className="font-display font-extrabold text-xl tracking-tight text-slate-900">
              Revora
            </span>
          </div>
          <h2 className="font-display font-bold text-2xl tracking-tight text-slate-900">
            Welcome back
          </h2>
          <p className="mt-2 text-slate-500 text-sm">
            Sign in to continue to your study workspace.
          </p>

          <Button
            data-testid="google-login-btn"
            onClick={handleLogin}
            disabled={loading}
            className="mt-8 w-full h-12 rounded-full bg-[#003366] hover:bg-[#00284d] text-white text-base font-medium transition-colors"
          >
            <img
              src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
              alt=""
              className="h-5 w-5 mr-2 bg-white rounded-full p-0.5"
            />
            {loading ? "Redirecting…" : "Continue with Google"}
          </Button>

          <p className="mt-6 text-xs text-slate-400 leading-relaxed">
            By continuing you agree to keep your study materials organized and your streaks alive.
          </p>
        </div>
      </div>
    </div>
  );
}
